(function(){
    const path = location.pathname.replace(/\/+$/, '') || '/';
    const params = new URLSearchParams(window.location.search);
    window.PAGE_CONTEXT = {
        path,
        paramsApk: params.get('apk'),
        isDesignMode: window.Shopify && window.Shopify.designMode,
        isSalePage: path.startsWith('/pages/sale-'),
        isDownloadPage: path.startsWith('/pages/download'),
        isHelpPage: path.startsWith('/pages/help'),
        isProjectsPage: path.startsWith('/pages/projects'),
        allowChat: !(
            path.startsWith('/pages/help') ||
            path.startsWith('/pages/download') ||
            path.startsWith('/pages/sale-')
        ),

        isIOS: getDeviceType() === 'iOS'
    };

    const loader = {
        script: (src, attrs = {}) => {
            loadElementOnce('script', `script[src*="${src}"]`, {async: true, src, ...attrs});
        },
        meta: (name, content, attrs = {}) => {
            loadElementOnce('meta', `meta[name="${name}"]`, {name, content, ...attrs});
        }
    };

    loader.script('https://static.cloudflareinsights.com/beacon.min.js', {'data-cf-beacon': '{"token": "92352a8bda6d4828aa4a6d84d74fb269"}', 'nonce':'2d11793502f7fa9039f8c16b3de7168e'});

    if (PAGE_CONTEXT.allowChat && !PAGE_CONTEXT.isDesignMode) {
        loader.script('https://plugin-code.salesmartly.com/js/project_594281_613220_1767748725.js',{'nonce':'2d11793502f7fa9039f8c16b3de7168e'});
    }

    loader.meta('baidu-site-verification','codeva-sTcdJiFlq6');

    const metaTag = document.querySelector('meta[name="google-site-verification"]');
    
    
    if (metaTag) {
        metaTag.remove();
    }

    if (PAGE_CONTEXT.isDownloadPage && typeof downloadApp === "function") {
        downloadApp();
    } 
})();

document.addEventListener('DOMContentLoaded', () => {
    pageContent();
    largeBoxBound();
    loopPlayer();
    faqController();

    if (PAGE_CONTEXT.isSalePage) {
        wechatQRCode();
        mapLocate();
    }

    if (PAGE_CONTEXT.allowChat) {
        // pageProtection();
        fromPopup();
    }

    if (PAGE_CONTEXT.isProjectsPage) videoPlay();

    if (PAGE_CONTEXT.isHelpPage) {
        helpDrawer();
        helpSidebar();
    }
});

function getDeviceType() {
    const ua = navigator.userAgent;
    const platform = navigator.platform;
    const touch = navigator.maxTouchPoints || 0;
    
    if (/Android/i.test(ua)) return 'Android';
    if (/iPhone|iPod/i.test(ua)) return 'iOS';
    if (/iPad/i.test(ua) || (platform === 'MacIntel' && touch > 1)) return 'iOS';
    if (/Win/i.test(platform) || /Windows/i.test(ua)) return 'Windows';
    if (/Mac/i.test(platform)) return 'Mac';
    if (/Linux/i.test(platform)) return 'Linux';

    return 'Other';
}

function helpDrawer() {
    const menu = document.querySelector('[data-module="menu"]')

    const binds = reflectionData('menu');
    const button = reflectionData('button', 'state')?.state[0];

    if (!binds || !menu) return;
    const menuCtrl = toggleClass(menu, 'translate-x-0');
    const openCtrl = toggleClass(binds?.open[0], 'hidden');
    const closeCtrl = toggleClass(binds?.close[0], 'hidden');

    const open = (e) => {
        e.stopPropagation();
        menuCtrl.open();
        openCtrl.open();
        closeCtrl.close();
        button.dataset.state = "menu:open";
    }
    const close = (e) => {
        e.stopPropagation();
        menuCtrl.close();
        openCtrl.close();
        closeCtrl.open();
        button.dataset.state = "menu:close";
        closeEvents.forEach(fn => fn());
        return;
    }

    let closeEvents = []
    listenEvent(button, 'click', e => {
        const state = button.dataset.state.split(':')[1]

        if(state !== 'open') open(e);
        else close(e);

        const unbindMask = listenEvent(document, 'click', evt => {
            if (!menu.contains(evt.target) && menuCtrl.isOpen()) close(evt);
        });

        const unbindEsc = listenEvent(document, 'keydown', evt => {
            if (evt.key === 'Escape' && menuCtrl.isOpen()) close(evt);
        })

        closeEvents.push(unbindMask, unbindEsc)
    });
}

function helpSidebar() {
    const nav = document.querySelector('[data-module="nav"]');
    const side = document.querySelector('[data-module="side"]');

    if (!nav || !side) return;

    const navBinds = reflectionData('nav');
    const sideBinds = reflectionData('side');

    let current = null;

    const setActive = (link) => {
        if (!link || link === current) return;

        current?.classList.remove('active-side');
        current?.classList.add('hover:bg-[#2c3950]');

        link.classList.add('active-side');
        link.classList.remove('hover:bg-[#2c3950]');
        current = link;
    };

    const firstKey = Object.keys(navBinds)[0];
    if (firstKey) setActive(navBinds[firstKey][0]);

    nav.addEventListener('click', (e) => {
        const link = e.target.closest('a[data-bind^="nav:"]');
        if (!link || !nav.contains(link)) return;

        setActive(link);
    });

    side.addEventListener('click', (e) => {
        const target = e.target.closest('[data-bind^="side:"]');
        if (!target || !side.contains(target)) return;

        const bind = target.dataset.bind;
        const key = bind.split(':')[1];
        const link = navBinds[key]?.[0];

        if (link) setActive(link);
    });
}

function pageProtection() {
    document.addEventListener('contextmenu', e => e.preventDefault());
    document.addEventListener('dragstart', e => e.preventDefault());
    
    const qrcode = document.querySelector('[data-img="QRCode"]');
    if (qrcode) {
        qrcode.addEventListener('contextmenu', e => {
        e.stopPropagation();
        });
    }
    document.addEventListener('keydown', e => {
        if ((e.ctrlKey && ["u", "s", "p"].includes(e.key.toLowerCase())) || e.key === "PrintScreen") {
            e.preventDefault();
        }
    });

    const video = document.querySelectorAll('video');
    video.forEach(v => {
        v.addEventListener('contextmenu', e => e.preventDefault());
        v.addEventListener('dragstart', e => e.preventDefault());
    });

    const emeProtection = () => {
    if (typeof MediaKeys !== 'undefined') {
        document.addEventListener('keydown', (e) => {
        if (e.key === 'PrintScreen') {
            e.preventDefault(); 
        }
        else if (e.key === 'r' && e.ctrlKey && e.altKey) {
            e.preventDefault();
        }
        });
    }
    };

    emeProtection();

    window.addEventListener('beforeprint', e => {
        showToast("Printing is disabled");
        e.preventDefault();
    });
}

function pageContent() {
    const navs = document.querySelectorAll('nav');
    const quote = `
        <div class="flex items-center">
        <a href="pages/contact" class="bg-primary rounded-sm px-3 text-center py-2 text-white">Get a Quote</a>
        </div>
        `; 
    if (!navs) return;

    navs.forEach(nav => {
        const currentLink = nav.querySelector('a[aria-current="page"]');
        if (!currentLink) return;

        let el = currentLink;
        let svg = null;
        let count = 0;

        while (el && count < 5) {
            count++;
            if (el.matches('[aria-label*="Page"]')) break;

            el.classList.add("text-primary");
            if (svg) svg.classList.add('text-primary');

            const li = el.closest('li')?.parentElement?.closest('li');
            if (!li) break;

            svg = li.querySelector('details')?.querySelector('svg');
            el = li.querySelector('details')?.querySelector('a');
            if (!el) break;  
        }
    });
}

function wechatQRCode() {
    const weChat = document.querySelector('[data-module=wechat]');
    const binds = reflectionData('wechat');
    if (!binds) return;

    const ctrl = toggleClass(weChat);
    if (!ctrl) return;

    let closeEvents = [];

    listenEvent(binds?.open[0], 'click', e => {
        e.stopPropagation();
        ctrl.open();

        closeEvents.forEach(fn => fn());
        closeEvents = [];

        const unbindClose = listenEvent(binds?.close[0], 'click', () => {
            ctrl.close();
            closeEvents.forEach(fn => fn());
        });

        const unbindMask = listenEvent(document, 'click', evt => {
            if (!weChat.contains(evt.target) && ctrl.isOpen()) {
                ctrl.close();
                closeEvents.forEach(fn => fn());
            }
        });

        const unbindEsc = listenEvent(document, 'keydown', evt => {
            if (evt.key === 'Escape' && ctrl.isOpen()) {
                ctrl.close();
                closeEvents.forEach(fn => fn());
            }
        });

        const unbindCopy = listenEvent(binds?.copy[0], 'click', evt => {
            evt.stopPropagation();
            copyText(evt.target);
        });
        closeEvents.push(unbindClose, unbindMask, unbindEsc, unbindCopy);
  });
}

async function mapLocate() {
  const map = document.querySelector('[data-module="map"]');
  const iframe = map?.querySelector('iframe');
  if (!map || !iframe) return;

  const binds = reflectionData('map');
  if (!binds) return;
  console.log(binds);

  loadMapIframe(iframe, map.dataset.position);

  const mapCtrl = toggleClass(map);
  const openCtrl = toggleClass(binds?.open[0], ['text-red', 'fill-red']);
  const iconCtrl = toggleClass(binds?.icon[0], 'border-red');

  let isOpen = false;
  let closeEvents = [];
  const openMap = () => {
    if (isOpen) return;
    isOpen = true;

    [mapCtrl, openCtrl, iconCtrl].forEach(ctrl => ctrl.open());
    (binds?.text[0]).textContent = 'Hide Map';

    closeEvents.forEach(fn => fn());
    closeEvents = [];

    const unbindMask = listenEvent(document, 'click', () => {
      closeMap();
    });

    closeEvents.push(unbindMask);
  };
  
  const closeMap = () => {
    if (!isOpen) return;
    isOpen = false;

    [mapCtrl, openCtrl, iconCtrl].forEach(ctrl => ctrl.close());
    (binds?.text[0]).textContent = 'View Map';

    closeEvents.forEach(fn => fn());
    closeEvents = [];
  };

  listenEvent(binds?.open[0], 'click', e => {
    e.stopPropagation();
    isOpen ? closeMap() : openMap();
  });
}

async function loadMapIframe(iframe, position) {
    if (!iframe) return;
    
    const lat = 23.08485;
    const lng = 113.19871;
    const label = "佛山市南海区辉旗喷泉";
    const encodedLabel = encodeURIComponent(label);

    let countryCode = null;
    try {
        const res = await fetch('https://ipapi.co/json/');
        const data = await res.json();
        countryCode = (data.country_code || '').toUpperCase();
    } catch (err) {
        console.warn('IP detection failed:', err);
    }

    const amap = `https://uri.amap.com/marker?position=${lng},${lat}&name=${encodedLabel}&src=www.huiqifountain.com&callnative=0`;
    const gmap = `https://www.google.com/maps?q=${encodedLabel}&hl=zh-CN&z=15&output=embed`;

    iframe.src = countryCode === 'CN' ? amap : gmap;
}

function applyI18n() {
    const data = window.__APP_I18N__;
    if (!data) return;

    const localang = localStorage.getItem('lang');
    const supportedLangs = ["zh", "en", "ja", "ru", "ar"];
    let lang = localang || navigator.language.slice(0,2);
    if (!supportedLangs.includes(lang)) lang = "en";

    const t = data[lang] || data.en;
    if (!t) return;
    
    document.querySelectorAll("[data-i18n]").forEach(el => {
        const key = el.dataset.i18n;
        if (!el.textContent) return;
        if (t[key]) el.textContent = t[key];
    });
}

function downloadApp() {
    const blocks = [...document.querySelectorAll('[data-key-auto]')];
    if (!blocks.length) return;

    applyI18n();

    const currentApk = PAGE_CONTEXT.paramsApk;
    const isIOS = PAGE_CONTEXT.isIOS;

    const matchedBlock = blocks.find(block => {
        const [params] = (block.dataset.keyAuto || '').split(';');
        return params && params === currentApk;
    }) || blocks[0];

    matchedBlock.classList.remove('hidden');
    matchedBlock.classList.add('opacity-100');

    blocks.forEach(block => {
        const [params, isAuto, delay] = (block.dataset.keyAuto || '').split(';');
        const [androidUrl, iosUrl] = (block.dataset.url || '').split(';');

        const target = iosUrl? (PAGE_CONTEXT.isIOS ? iosUrl : androidUrl) : androidUrl;


        const btn = block.querySelector('.btn');
        if (btn && target) btn.href = target;

        if (!PAGE_CONTEXT.isDesignMode && isAuto === 'true' && target && block === matchedBlock) handleAutoDownload(target, delay);
    });  
}

function handleAutoDownload(url, seconds = 3) {
    if (!url || seconds < 0 ) return;
    const tick = () => {
        if (seconds == 0) {
            // showToast("Download...");
            setTimeout(() => { location.href = url; }, 400);
        }else {
            showToast(`Download is about to begin (${seconds}s)...`);
            seconds--;
            setTimeout(tick, 1000);
        }
    }
    tick();
}

function fromPopup() {
    const popup = document.querySelector('[data-module="popup"]')
    const binds = reflectionData('popup');
    
    if (!popup || !binds) return;

    const ctrl = toggleClass(popup);

    let closeEvents = [];
    listenEvent(binds?.open[0], 'click', e => {
        e.preventDefault();
        ctrl.open();
        popup.classList.add('has:overflow');
        
        closeEvents.forEach(fn => fn());
        closeEvents = [];
        
        binds?.close?.forEach(btn => {
            const unbindClose = listenEvent(btn, 'click', evt => {
                evt.preventDefault();
                ctrl.close();
                popup.classList.remove('has:overflow');
                closeEvents.forEach(fn => fn());
                }
            );
            closeEvents.push(unbindClose);
        })
        
        const unbindMask = listenEvent(document, 'click', evt => {
            if (evt.target === binds?.overlay[0] && ctrl.isOpen() ) {
                ctrl.close();
                popup.classList.remove('has:overflow');
                closeEvents.forEach(fn => fn());
            }
        });
        closeEvents.push(unbindMask);
    });   
}

function videoPlay() {
    const videos = reflectionData('autoplay','video');

    const obs = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            entry.target[entry.isIntersecting ? 'play' : 'pause']();
        });
    }, {threshold: 0.3});

    videos?.['false']?.forEach(v => {
        v.pause();
        obs.observe(v);
    });
}

function loopPlayer() {
    const binds = reflectionData('process');
    if (!binds?.step?.[0] || !binds?.item?.[0]) return;

    const track = binds.step[0];
    let index = 0, step = 0, maxIndex = 0, startX = 0, deltaX = 0, isDragging = false;

    const updateMetrics = () => {
        const gap = parseInt(getComputedStyle(track).gap) || 0;
        step = binds.item[0].offsetWidth + gap;
        const raw = (track.scrollWidth - track.parentElement.offsetWidth) / step;
        maxIndex = Math.abs(raw - Math.round(raw)) < 0.01 ? Math.floor(raw) : Math.ceil(raw);
    };

    const render = () => {
        let translate = Math.min(index * step, track.scrollWidth - track.parentElement.offsetWidth);
        track.style.transform = `translateX(-${translate}px)`;
    };

    const slideTo = (newIndex) => {
        index = Math.max(0, Math.min(newIndex, maxIndex));
        render();
    };

    binds.nextBtn?.[0]?.addEventListener("click", () => slideTo(index + 1));
    binds.prevBtn?.[0]?.addEventListener("click", () => slideTo(index - 1));

    track.addEventListener("touchstart", e => { isDragging = true; startX = e.touches[0].clientX; });
    
    track.addEventListener("touchmove", e => { if (isDragging) deltaX = e.touches[0].clientX - startX; });

    track.addEventListener("touchend", () => {
        if (!isDragging) return; isDragging = false;
        if (deltaX < -step/4) slideTo(index + 1);
        else if (deltaX > step/4) slideTo(index - 1);
        deltaX = 0;
    });

    window.addEventListener("resize", () => { updateMetrics(); if (index > maxIndex) index = maxIndex; render(); });

    updateMetrics();
    render();
}

function largeBoxBound() {
    const modules = reflectionData('', 'module');
    const binds = reflectionData(['state', 'large', 'gallery'])
    const counts = document.querySelector('[data-count]')?.dataset?.count
    if (!modules || !binds || !counts) return;
    
    const { gallery, large } = modules
    const { hide, close, img, text, load } = binds
    const { mobile, batch, desktop } = strcut(counts)
    
    const mainImg = img[0].querySelector('img');
    const isMobile = window.innerWidth <= 768;
    const initialCount = parseInt(isMobile ? mobile : desktop) || 0;

    const ctrl = toggleClass(large[0]);
    
    const showItem = (el) => {
        el.classList.remove("hidden");
        el.dataset.bind = 'state:show';
    };
    
    hide.forEach((item, index) => {
        if (index < initialCount) showItem(item);
    });

    listenEvent(gallery[0], 'click', e => {
        const target = e.target;
        const li = target.closest('li');

        if (li && hide.includes(li)) {
            mainImg.srcset = target.srcset || '';
            text[0].textContent = target.alt || '';

            document.body.style.overflow = 'hidden';
            ctrl.open();
            return;
        }

        if (large.includes(target) || close[0].contains(target)) {
            document.body.style.overflow = '';
            ctrl.close();
            return;
        }

        if (load[0] && load[0].contains(target)) {
            const hiddenItems = hide.filter(item => item.dataset.bind === 'state:hide');
            const batchSize = parseInt(batch) || 0;
            
            hiddenItems.slice(0, batchSize).forEach(showItem);

            if (hiddenItems.length <= batchSize) {
                load[0].classList.add('hidden');
            }
        }
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target;
                el.classList.add('opacity-100', 'translate-0');
                observer.unobserve(el); 
            }
        });
    }, { threshold: 0.1 });

    hide.forEach(block => observer.observe(block));  
}

function faqController() {
    const b = reflectionData('faq');
    if (!b) return;

    const cats = b.category || [];
    const items = b.attribution || [];
    const qs = b.question || [];
    const ans = b.answer || [];
    const icons = b.icon || [];

    const getCat = el => el?.dataset?.cat;

    let hash = location.hash.slice(1);

    let active = '';
    function switchCat(cat) {
        active = cat;
        cats.forEach(li => { li.setAttribute('state', getCat(li) === cat ? 'active' : ''); });

        let firstIndex = -1;
        items.forEach((item, i) => {
            const c = getCat(qs[i]);
            const show = c === cat;
            
            item.classList.toggle('hidden', !show);

            if (show && firstIndex === -1) firstIndex = i;

            ans[i].style.maxHeight = null;
            ans[i].classList.remove('opacity-100');

            icons[i]?.classList.remove('rotate-180');

            qs[i]?.classList.remove('bg-dark', 'text-white');
        });

        if (hash) {
            const i = items.findIndex(el => el.id === hash);
            if (i > -1) {
                toggleFaq(i);
                return;
            }
        }

        if (firstIndex > -1) toggleFaq(firstIndex);
    }

    function toggleFaq(i) {
        const el = ans[i];
        const isOpen = el.classList.contains('opacity-100');

        ans.forEach((a, idx) => {
            a.style.maxHeight = null;
            a.classList.remove('opacity-100');

            icons[idx]?.classList.remove('rotate-180');
            qs[idx]?.classList.remove('bg-dark', 'text-white');
        });

        if (!isOpen) {
            el.classList.add('opacity-100');
            el.style.maxHeight = el.scrollHeight + 'px';

            icons[i]?.classList.add('rotate-180');
            qs[i]?.classList.add('bg-dark', 'text-white');
        }
    }

    listenEvent(document, 'click', e => {
        const catEl = e.target.closest('[data-bind="faq:category"] li');
        if (catEl) {
            e.preventDefault();

            const c = getCat(catEl);
            if (c && c !== active) {
                hash = '';
                switchCat(c);
            }
            return;
        }

        const q = e.target.closest('[data-bind="faq:question"]');
        if (q) {
            e.preventDefault();

            const i = qs.indexOf(q);
            if (i > -1) toggleFaq(i);
        }
    });
}

function listenEvent(target = document, events, callback) {
    if (!target || !callback || typeof callback !== 'function') return () => {};
    const eventList = Array.isArray(events) ? events : [events];

    const handlers = eventList.map(event => {
        const handler = e => callback(e);
        target.addEventListener(event, handler);
        return { event, handler };
    });

    return () => handlers.forEach(({ event, handler }) => target.removeEventListener(event, handler));
}

function toggleClass(el, classes) {
    if (!el) return null;

    const defaultClasses = ['opacity-100', 'visible', 'events-auto'];

    let list = [];

    if (Array.isArray(classes)) {
        list = classes;
    } else if (typeof classes === 'string') {
        list = [classes];
    } else {
        list = defaultClasses;
    }

    return {
        open() {
            el.classList.add(...list);
        },
        close() {
            el.classList.remove(...list);
        },
        toggle() {
            list.forEach(cls => el.classList.toggle(cls));
        },
        isOpen() {
            return list.every(cls => el.classList.contains(cls));
        }
    };
}

function showToast(message) {
  const toast = document.createElement('div');
  toast.textContent = message;
  Object.assign(toast.style, {
    position: 'fixed',
    left: '50%',
    bottom: '20%',
    transform: 'translate(-50%, -20%)',
    background: 'rgba(0,0,0,0.75)',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '6px',
    fontSize: '14px',
    opacity: '0',
    transition: 'opacity 0.4s ease',
    zIndex: '9999',
  });
  
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => {
      toast.remove();
    }, 200);
  }, 2000);
}

function copyText(el) {
    const text = el.dataset.text;
    if (!text || !navigator.clipboard) return;

    navigator.clipboard.writeText(text)
        .then(() => showToast('Copied!'))
        .catch(() => showToast('Copy failed'));
}

function reflectionData(name, attr = 'bind', root = document) {
    const names = (Array.isArray(name) ? name : [name])
        .map(v => typeof v === 'string' ? v.trim() : '')
        .filter(Boolean);

    const hasName = names.length > 0;

    const result = [...root.querySelectorAll(`[data-${attr}]`)]
        .reduce((acc, el) => {
            const value = el.dataset[attr];
            if (!value) return acc;

            if (hasName) {
                const [n, action] = value.split(':');
                if (!action || !names.includes(n)) return acc;

                (acc[action] ??= []).push(el);
            } else {
                (acc[value] ??= []).push(el);
            }

            return acc;
        }, Object.create(null));

    return Object.keys(result).length ? result : null;
}

function strcut(data, sep1 = ';', sep2 = ':') {
    return Object.fromEntries(
        (data ?? '')
        .split(sep1)
        .map(v => v.trim())
        .filter(Boolean)
        .map(v => v.split(sep2))
    )
}

function loadElementOnce(tag, selector, attrs = {}) {
    const targets = document.querySelectorAll(selector);
    const isDuplicate = [...targets].some(target => {
        return Object.entries(attrs).every(([key, value]) => {
            return target.getAttribute(key) === String(value) || target[key] === value;
        })
    })

    if (isDuplicate) return;

    const head = document.head || document.getElementsByTagName('head')[0];
    const el = document.createElement(tag);

    Object.entries(attrs).forEach(([key, value]) => {
        if (key in el) {
            el[key] = value;
        } else {
            el.setAttribute(key, value);
        }
    });

    head.appendChild(el);
}


function gTagManager() {
     /*
     // head
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-N23WQQM2');
    
    // body
    <noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N23WQQM2"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
    */
}